import { computed, observable, makeObservable } from "mobx";
import { v4 } from 'uuid';
import { StoreNode } from '../../store';

const KEY = 'analytics.installContextUid';

enum IdTypes {
  Persistent = 'persistent',
  Transient = 'transient'
}

export type InstallContextType = {
  id: string,
  idType: IdTypes,
}

/**
 * Class that generates an UUID for session tracking purposes.
 * It tries to save the UUID in local or session storage if it has permissions.
 */
export class InstallContext extends StoreNode {

  constructor(...args: ConstructorParameters<typeof StoreNode>) {
    super(...args);
    makeObservable(this, {
      uid: observable,
      storage: computed,
      hasLocalStorage: computed,
      idType: computed,
    });
  }

  uid: string | null = null;

  get storage() {
    return this.store.storage;
  }

  get hasLocalStorage() {
    return this.storage.hasLocalStorage;
  }

  get idType(): IdTypes {
    return this.hasLocalStorage ? IdTypes.Persistent : IdTypes.Transient;
  }

  init() {
    const existing = this.storage.getLocalOrSession(KEY);

    if (existing) {
      this.uid = existing;
    } else {
      const uid = v4();
      this.uid = uid;

      this.storage.setLocalOrSession(KEY, uid);
    }
  }


  export(): InstallContextType {
    return {
      id: this.uid || '',
      idType: this.idType
    }
  }
}